import React, { useEffect, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import {
  Button,
  Col,
  Divider,
  Dropdown,
  Icon,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Table,
  Typography,
  Upload,
  Select,
} from "antd";

import Loader from "components/Loader/Loader";
// import FloatingActionButton from "components/FloatingActionButton/FloatingActionButton";

import emptyImage from "../../media/empty-survey-list.svg";

import {
  archiveCohortApi,
  createCohortApi,
  deleteCohortApi,
  fetchCohortAdminListApi,
  fetchCohortCountApi,
  importCohortApi,
  updateCohortNameApi,
} from "utils/apiService";
import moment from "moment";

const { Text } = Typography;
const { Dragger } = Upload;

const CohortsTable = (props) => {
  const { data } = props;

  const [deleteModal, setDeleteModal] = useState(false);
  const deleteCohort = useRef("");

  const [updateModal, setUpdateModal] = useState(false);
  const updateCohort = useRef({
    name: "",
    uuid: "",
  });

  const columns = [
    {
      title: "Cohort Name",
      dataIndex: "name",
      key: "cohortName",
      render: (data) => {
        return (
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#181818",
              whiteSpace: "nowrap",
            }}
          >
            {data ? data : "-"}
          </Text>
        );
      },
    },
    {
      title: "No. of Customers",
      dataIndex: "total_customers",
      key: "customerCount",
      render: (data) => {
        return (
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#181818",
              whiteSpace: "nowrap",
            }}
          >
            {data ? data : "0"}
          </Text>
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "date_created",
      key: "createdOn",
      render: (data) => {
        const date = new Date(data);
				const formattedDate = moment(date).format("DD/MM/YYYY");
        return (
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#181818",
              whiteSpace: "nowrap",
            }}
          >
            {data ? formattedDate : "-"}
          </Text>
        );
      },
    },
    {
      title: "",
      dataIndex: ["uuid", "name"],
      key: "uuid",
      render: (_, row) => {
        return (
          <div style={{ width: "16px" }}>
            {!props.viewOnly ? (
              <Dropdown
                placement={"bottomLeft"}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{ marginLeft: "0" }}
                overlay={
                  <Menu>
                    <Menu.Item
                      onClick={(e) => {
                        e.domEvent.stopPropagation();
                        updateCohort.current = {
                          uuid: row.uuid,
                          name: row.name,
                        };
                        setUpdateModal(true);
                      }}
                    >
                      <Text style={{ color: "#181818" }}>Rename Cohort</Text>
                    </Menu.Item>
                    <Menu.Item
                      onClick={(e) => {
                        e.domEvent.stopPropagation();
                        archiveCohortApi({
                          requestData: {
                            uuid: row.uuid,
                            status: props.noAction ? "unarchive" : "archive",
                          },
                          res200Callback: () => {
                            props.updatePage(data.pageNum);
                          },
                        });
                      }}
                    >
                      <Text style={{ color: "#181818" }}>
                        {props.noAction ? "Unarchive" : "Archive"}
                      </Text>
                    </Menu.Item>
                    {row.name !== "Cohort1" && (
                      <Menu.Item
                        onClick={(e) => {
                          e.domEvent.stopPropagation();
                          deleteCohort.current = row.uuid;
                          setDeleteModal(true);
                        }}
                      >
                        <Text style={{ color: "#F5222D" }}>Delete</Text>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <Icon
                  type="more"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  style={{
                    fontSize: "16px",
                    color: "#747474",
                    marginLeft: "52px",
                  }}
                />
              </Dropdown>
            ) : (
              <></>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Table
        // rowSelection={props.noAction ? null : rowSelection}
        columns={(function () {
          // if (props.noAction) {
          // 	return columns.filter((item) => item.key != "x");
          // }
          return columns;
        })()}
        dataSource={data.cohorts}
        pagination={{ showQuickJumper: true, pageSize: data.pageSize }}
        style={{ overflow: "none" }}
        onChange={(pagination) => {
          props.updatePage(pagination.current);
        }}
        onRow={(obj) => ({
          onClick: () => {
            return !props.viewOnly
              ? props.history.push(`${props.location?.pathname}/${obj?.uuid}`)
              : "";
          },
        })}
        loading={props.loading}
      />
      <Modal
        centered
        visible={updateModal}
        destroyOnClose
        maskClosable={false}
        onCancel={() => setUpdateModal(false)}
        footer={null}
      >
        <Row className="modal-row">
          <Row>
            <Icon
              type="edit"
              style={{
                color: "#181818",
                fontSize: "24px",
                marginRight: "16px",
              }}
            />
            <Text
              style={{
                fontWeight: "bold",
                color: "#181818",
                fontSize: "24px",
              }}
            >
              Change Cohort Name
            </Text>
          </Row>
          <Row style={{ marginTop: "24px" }}>
            <div>
              <Text
                style={{
                  fontSize: "14px",
                  color: "#181818",
                  fontWeight: "bold",
                  // fontWeight:"bold"
                }}
              >
                Cohort Name
              </Text>
              <Input
                className="time-value-cohort-col-main-element"
                style={{ width: "100%", marginTop: "8px" }}
                placeholder="Enter a cohort name"
                defaultValue={updateCohort.current.name}
                onChange={(e) => {
                  updateCohort.current.name = e.target.value;
                }}
              />
            </div>
            <Col
              style={{
                marginTop: "60px",
                textAlign: "right",
              }}
              span={18}
            >
              <Button
                size="large"
                style={{
                  height: "40px",
                  boxShadow: "none",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "#FFFFFF",
                  color: "#181818",
                }}
                onClick={() => setUpdateModal(false)}
              >
                Cancel
              </Button>
            </Col>
            <Col
              style={{
                marginTop: "60px",
                textAlign: "right",
              }}
              span={6}
            >
              <Button
                size="large"
                style={{
                  height: "40px",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "#fec708",
                  color: "#FFFFFF",
                }}
                onClick={() => {
                  updateCohortNameApi({
                    requestData: updateCohort.current,
                    res200Callback: () => {
                      setUpdateModal(false);
                      props.updatePage(data.pageNum);
                    },
                  });
                }}
              >
                Update
              </Button>
            </Col>
          </Row>
        </Row>
      </Modal>
      <Modal
        centered
        visible={deleteModal}
        destroyOnClose
        maskClosable={false}
        onCancel={() => setDeleteModal(false)}
        footer={null}
      >
        <Row className="modal-row">
          <Row>
            <Icon
              type="delete"
              style={{
                color: "#181818",
                fontSize: "24px",
                marginRight: "16px",
              }}
            />
            <Text
              style={{
                fontWeight: "bold",
                color: "#181818",
                fontSize: "24px",
              }}
            >
              Delete item
            </Text>
          </Row>
          <Row style={{ marginTop: "24px" }}>
            <Col span={24}>
              <Text>Are you sure you want to delete this Cohort?</Text>
            </Col>
            <Col
              style={{
                marginTop: "60px",
                textAlign: "right",
              }}
              span={18}
            >
              <Button
                size="large"
                style={{
                  height: "40px",
                  boxShadow: "none",
                  borderRadius: "20px",
                  border: "none",
                  backgroundColor: "#FFFFFF",
                  color: "#181818",
                }}
                onClick={() => setDeleteModal(false)}
              >
                Cancel
              </Button>
            </Col>
            <Col
              style={{
                marginTop: "60px",
                textAlign: "right",
              }}
              span={6}
            >
              <Button
                size="large"
                style={{
                  height: "40px",
                  borderRadius: "2px",
                  border: "none",
                  backgroundColor: "#C91713",
                  color: "#FFFFFF",
                }}
                onClick={() => {
                  deleteCohortApi({
                    requestData: {
                      uuid: deleteCohort.current,
                    },
                    res200Callback: () => {
                      setDeleteModal(false);
                      props.updatePage(data.pageNum);
                    },
                  });
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        </Row>
      </Modal>
    </>
  );
};
export default CohortsTable;
